// src/components/charts/VisitantesChart.jsx
import React, { useState, useEffect } from 'react';
import { Card, Alert, Spinner } from 'react-bootstrap';
import LineChart from '../agComponents/LineChart';
import kpiService from '../../services/kpiService';

/**
 * Componente que muestra el gráfico de visitantes reales vs proyectados
 * Obtiene datos dinámicamente desde kpiService
 */
const VisitantesChart = ({ fechaInicio, fechaFin, localId }) => {
  const [chartData, setChartData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      setError(null);

      try {
        const response = await kpiService.getVisitantesRealesVsProyectados({
          fechaInicio,
          fechaFin,
          localId,
        });

        if (response.success) {
          setChartData(response.data);
        } else {
          throw new Error('No se pudieron cargar los datos');
        }
      } catch (err) {
        console.error('Error fetching visitantes data:', err);
        setError('Error al cargar el gráfico. Por favor, intenta nuevamente.');
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [fechaInicio, fechaFin, localId]);

  if (error) {
    return (
      <Card>
        <Card.Body>
          <Alert variant="danger">{error}</Alert>
        </Card.Body>
      </Card>
    );
  }

  if (loading) {
    return (
      <Card>
        <Card.Body className="text-center py-5">
          <Spinner animation="border" variant="primary" />
          <p className="mt-3 text-muted">Cargando datos...</p>
        </Card.Body>
      </Card>
    );
  }

  return (
    <Card>
      <Card.Body>
        <h5 className="mb-3">Visitantes reales vs proyectados</h5>
        
        <LineChart
          data={chartData.data}
          xKey="day"
          series={chartData.series}
          height={350}
        />

        {/* Leyenda personalizada con presupuesto */}
        {chartData.data?.[0]?.budget && (
          <div className="mt-3 text-center text-muted small">
            <span className="me-3">
              <span className="badge bg-secondary">Budget:</span>{' '}
              {chartData.data[0].budget.toLocaleString('es-ES')} €
            </span>
          </div>
        )}
      </Card.Body>
    </Card>
  );
};

export default VisitantesChart;